import { EUAppConfig } from '@eucoms/common-components';

// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// The list of which env maps to which file can be found in `.angular-cli.json`.
export const environment: any = {
  production: false,
  devEnvironment: false,
  name: 'azdev',
  appConfig: {
    isSummaryMappingEditableFlag: true,
    isJourneyConfigEditableFlag: true,
    adminRoles: ['Custtp.Admin'],
    common: {
      custtpApiUrl: 'https://not-set',
      custtpApiScopes: [
        `d3a28479-0af2-4721-b002-5aceb89780a6/CustomerData.Read`,
        `d3a28479-0af2-4721-b002-5aceb89780a6/CustomerData.Write`,
        `d3a28479-0af2-4721-b002-5aceb89780a6/Admin.All`
      ],
      custtpApiClientId: 'd3a28479-0af2-4721-b002-5aceb89780a6',
      isPreviewUsingProxy: false,
      ssipApiUrl: '/api',
      ssipClientId: '2eaba78f-77da-455a-a51c-cae048f1719d',
      ssipAuthority: 'https://login.microsoftonline.com/600d01fc-055f-49c6-868f-3ecfcc791773', //dev/test/stage/prod
    },
    ACE: {
      custtpApiUrl: 'https://eudapi-dev.atlanticcityelectric.com/custtp',
    },
    BGE: {
      custtpApiUrl: 'https://eudapi-dev.bge.com/custtp',
    },
    ComEd: {
      custtpApiUrl: 'https://eudapi-dev.comed.com/custtp',
    },
    DPL: {
      custtpApiUrl: 'https://eudapi-dev.delmarva.com/custtp',
    },
    PECO: {
      custtpApiUrl: 'https://eudapi-dev.peco.com/custtp',
    },
    PEPCO: {
      custtpApiUrl: 'https://eudapi-dev.pepco.com/custtp',
    }
  } as EUAppConfig,
};
